function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 27,
  r: 24,
  fill: "#6DC4F2"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.52 38C15.52 36.4267 15.6933 35.0267 16.04 33.8C16.4133 32.5733 17.0533 31.4667 17.96 30.48C18.8667 29.4933 20.1467 28.5333 21.8 27.6C23.2667 26.8267 24.4933 26.1733 25.48 25.64C26.4667 25.1067 27.2133 24.6 27.72 24.12C28.2533 23.6133 28.52 23.0267 28.52 22.36C28.52 21.56 28.2 20.88 27.56 20.32C26.92 19.7333 26.0133 19.44 24.84 19.44C23.56 19.44 22.4533 19.7467 21.52 20.36C20.6133 20.9733 19.8267 21.68 19.16 22.48L15.76 18.56C16.24 18.0533 16.96 17.5067 17.92 16.92C18.88 16.3333 20.0267 15.8267 21.36 15.4C22.6933 14.9733 24.16 14.76 25.76 14.76C28.48 14.76 30.5867 15.4 32.08 16.68C33.6 17.9333 34.36 19.56 34.36 21.56C34.36 22.8133 34.0667 23.88 33.48 24.76C32.92 25.6133 32.2133 26.3467 31.36 26.96C30.5333 27.5467 29.7333 28.0667 28.96 28.52C27.2533 29.3733 25.9067 30.12 24.92 30.76C23.96 31.4 23.1867 32.2 22.6 33.16H34.8V38H15.52Z",
  fill: "white"
});
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 51,
    viewBox: "0 0 48 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.047c1b7b3b7df514b51edd46aef31a61.svg";
export { ForwardRef as ReactComponent };